import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./Breadcrumb.css";
import { 
  PATH_PRODUCT_TYPE, 
  PATH_BRAND, 
  PATH_CATEGORY 
} from "../../../constants/Paths";

const Breadcrumb = ({ items, currentLevel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBreadcrumbClick = (level, item) => {
    switch (level) {
      case 'type':
        // Navigate to Product Type screen and clear brand/category selections
        dispatch({ type: "UPDATE_SELECTED_BRAND", payload: null });
        dispatch({ type: "UPDATE_SELECTED_CATEGORY", payload: null });
        navigate(PATH_PRODUCT_TYPE, { replace: true });
        break;
      
      case 'brand':
        // Navigate to Brand screen and clear category selection
        dispatch({ type: "UPDATE_SELECTED_CATEGORY", payload: null });
        navigate(PATH_BRAND, { replace: true });
        break;
        
      case 'category':
        // Navigate to Category screen
        navigate(PATH_CATEGORY, { replace: true });
        break;
        
      default:
        break;
    }
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="breadcrumb-container">
      <div className="breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isCurrent = item.level === currentLevel;
          
          return (
            <React.Fragment key={index}>
              <span
                className={`breadcrumb-item ${isCurrent ? 'current' : 'clickable'}`}
                onClick={!isCurrent ? () => handleBreadcrumbClick(item.level, item) : undefined}
              >
                {item.title || item.name || item}
              </span>
              {!isLast && <span className="breadcrumb-separator">></span>}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumb;